
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import API, { auth } from '../../constants/api';
import {
  BANNER_FETCH,
  BANNER_DETAIL_FETCH,
  CATEGORY_FETCH,
  PROGRAM_DETAIL_FETCH,
  PROGRAM_DETAIL_PREVIEW_FETCH,
  FAVORITE_SEND_FETCH,
  SEARCH_FETCH,
  ALL_PROGRAM_FETCH,
  PROGRAM_PLAY_FETCH,
  LIVE_FETCH,
  CURRENT_PLAY_FETCH,
  SHARE_FETCH,
  CLICK_SHARE_FETCH,

} from '../actions';

import {
  bannerFetchSuccess,
  bannerFetchFail,
  bannerDetailFetchSuccess,
  bannerDetailFetchFail,
  categoryFetchSuccess,
  categoryFetchFail,
  programDetailFetchSuccess,
  programDetailFetchFail,
  favoriteSendFetchSuccess,
  favoriteSendFetchFail,
  searchFetchSuccess,
  searchFetchFail,
  allProgramFetchSuccess,
  allProgramFetchFail,
  programPlayFetchSuccess,
  programPlayFetchFail,
  liveListFetchSuccess,
  liveListFetchFail,
  currentPlayFetchSuccess,
  currentPlayFetchFail,
  programDetailPreviewFetchSuccess,
  programDetailPreviewFetchFail,
  programShareFetchSuccess,
  programShareFetchFail,
  clickProgramShareFetchSuccess,
  clickProgramShareFetchFail,
} from './actions';

import { sortOrder } from '../../helpers/Utils';

/* banner */
const bannerFetchAsync = async (req) =>
  await API.post('/program/banner', {
    "position": "home_top"
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* bannerFetch({ payload }) {
  const { banner } = payload
  try {
    const bannerFetch = yield call(bannerFetchAsync, banner)

    if (bannerFetch.data.StatusCode === '0000') {
      yield put(bannerFetchSuccess(bannerFetch.data.ResultValues))
    } else {
      yield put(bannerFetchFail(bannerFetch.data.Message))
    }
  } catch (error) {
    yield put(bannerFetchFail(error))
  }
}

/* banner detail */
const bannerDetailFetchAsync = async (req) =>
  await API.post('/program/banner/detail', {
    "bannerId": req.bannerId
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* bannerDetailFetch({ payload }) {
  const { bannerDetail } = payload
  try {
    const bannerDetailFetch = yield call(bannerDetailFetchAsync, bannerDetail)

    if (bannerDetailFetch.data.StatusCode === '0000') {
      yield put(bannerDetailFetchSuccess(bannerDetailFetch.data.ResultValues))
    } else {
      yield put(bannerDetailFetchFail(bannerDetailFetch.data.Message))
    }
  } catch (error) {
    yield put(bannerDetailFetchFail(error))
  }
}

/* category */
const categoryFetchAsync = async (req) =>
  await API.post('/program/category', {
    "memberId": req.memberId,
    "platform": "web"
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* categoryFetch({ payload }) {
  const { category } = payload
  try {
    const categoryFetch = yield call(categoryFetchAsync, category)

    if (categoryFetch.data.StatusCode === '0000') {
      yield put(categoryFetchSuccess(categoryFetch.data.ResultValues))
    } else {
      yield put(categoryFetchFail(categoryFetch.data.Message))
    }
  } catch (error) {
    yield put(categoryFetchFail(error))
  }
}

/* program detail */
const programDetailFetchAsync = async (req) =>
  await API.post('/program/detail', {
    "programId": req.programId,
    "memberId": req.memberId,
    "platform": "web",
    "playList": req.playList
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* programDetailFetch({ payload }) {
  const { programDetail } = payload
  try {
    const programDetailFetch = yield call(programDetailFetchAsync, programDetail)

    if (programDetailFetch.data.StatusCode === '0000') {
      yield put(programDetailFetchSuccess(programDetailFetch.data.ResultValues))
    } else {
      // console.log('programDetailFetch -> ', programDetailFetch.data.Message)
      yield put(programDetailFetchFail(programDetailFetch.data.Message))
    }
  } catch (error) {
    yield put(programDetailFetchFail(error))
  }
}

/* favorite send */
const favoriteSendFetchAsync = async (req) =>
  await API.post('/program/favorite', {
    "programId": req.programId,
    "memberId": req.memberId
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* favoriteSendFetch({ payload }) {
  const { favoriteSend } = payload
  try {
    const favoriteSendFetch = yield call(favoriteSendFetchAsync, favoriteSend)

    if (favoriteSendFetch.data.StatusCode === '0000') {
      yield put(favoriteSendFetchSuccess(favoriteSendFetch.data.Message))
    } else {
      yield put(favoriteSendFetchFail(favoriteSendFetch.data.Message))
    }
  } catch (error) {
    yield put(favoriteSendFetchFail(error))
  }
}

/* search */
const searchFetchAsync = async (req) =>
  await API.post('/program/search', {
    "search": req.search,
    "memberId": req.memberId
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* searchFetch({ payload }) {
  const { search } = payload
  try {
    const searchFetch = yield call(searchFetchAsync, search)

    if (searchFetch.data.StatusCode === '0000') {
      yield put(searchFetchSuccess(searchFetch.data.ResultValues))
    } else {
      yield put(searchFetchFail(searchFetch.data.Message))
    }
  } catch (error) {
    yield put(searchFetchFail(error))
  }
}

/* all Program */
const allProgramFetchAsync = async (req) =>
  await API.post('/program/all/category', {
    "memberId": req.memberId,
    "categoryId": req.categoryId,
    "subCategoryId": req.subCategoryId,
    "categoryPosition": req.categoryPosition,
    "platform": "web",
    "page": req.page,
    "limit": req.limit,
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* allProgramFetch({ payload }) {
  const { allProgram } = payload
  try {
    const allProgramFetch = yield call(allProgramFetchAsync, allProgram)

    if (allProgramFetch.data.StatusCode === '0000') {
      yield put(allProgramFetchSuccess(allProgramFetch.data))
    } else {
      yield put(allProgramFetchFail(allProgramFetch.data.Message))
    }
  } catch (error) {
    yield put(allProgramFetchFail(error))
  }
}

/* Program play */
const programPlayFetchAsync = async (req) =>
  await API.post('/program/play', {
    "memberId": req.memberId,
    "programId": req.programId
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* programPlayFetch({ payload }) {
  const { programPlay } = payload
  try {
    const programPlayFetch = yield call(programPlayFetchAsync, programPlay)

    if (programPlayFetch.data.StatusCode === '0000') {
      yield put(programPlayFetchSuccess(programPlayFetch.data.ResultValues))
    } else {
      yield put(programPlayFetchFail(programPlayFetch.data.Message))
    }
  } catch (error) {
    yield put(programPlayFetchFail(error))
  }
}

/* live */
const liveListFetchAsync = async (req) =>
  await API.post('/live', {
    "memberId": req.memberId,
    "userId": req.userId
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* liveListFetch({ payload }) {
  const { liveList } = payload
  try {
    const liveListFetch = yield call(liveListFetchAsync, liveList)

    if (liveListFetch.data.StatusCode === '0000') {
      const resultValues = liveListFetch.data.ResultValues.sort((a, b) => a.id - b.id)
      const userId = liveListFetch.data.userId
      const userSign = liveListFetch.data.userSign
      // console.log('data -> ', liveListFetch.data)
      localStorage.setItem('AppVersion', liveListFetch.data.AppVersion)
      yield put(liveListFetchSuccess(resultValues, userId, userSign))
    } else {
      localStorage.setItem('AppVersion', liveListFetch.data.AppVersion)

      yield put(liveListFetchFail(liveListFetch.data.Message))
    }
  } catch (error) {
    yield put(liveListFetchFail(error))
  }
}

/* current play */
const currentPlayFetchAsync = async (req) =>
  await API.post('/program/currentplay', {
    "memberId": req.memberId,
    "programId": req.programId,
    "currentTime": req.currentTime
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* currentPlayFetch({ payload }) {
  const { currentPlay } = payload
  try {
    const currentPlayFetch = yield call(currentPlayFetchAsync, currentPlay)

    if (currentPlayFetch.data.StatusCode === '0000') {
      yield put(currentPlayFetchSuccess(currentPlayFetch.data.ResultValues))
    } else {
      yield put(currentPlayFetchFail(currentPlayFetch.data.Message))
    }
  } catch (error) {
    yield put(currentPlayFetchFail(error))
  }
}


/* program detail */
const programDetailPreviewFetchAsync = async (req) =>
  await API.post('/program/preview', {
    "token": req.programId,
    "memberId": req.memberId
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* programDetailPreviewFetch({ payload }) {
  const { programDetailPreview } = payload
  try {
    const programDetailPreviewFetch = yield call(programDetailPreviewFetchAsync, programDetailPreview)

    if (programDetailPreviewFetch.data.StatusCode === '0000') {
      yield put(programDetailPreviewFetchSuccess(programDetailPreviewFetch.data.ResultValues))
    } else {
      // console.log('programDetailPreviewFetch -> ', programDetailPreviewFetch.data.Message)
      yield put(programDetailPreviewFetchFail(programDetailPreviewFetch.data.Message))
    }
  } catch (error) {
    yield put(programDetailPreviewFetchFail(error))
  }
}


/* banner */
const programShareFetchAsync = async (req) =>
  await API.post('/program/share', {
    "programId": req.programId
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* programShareFetch({ payload }) {
  const { programShare } = payload
  try {
    const programShareFetch = yield call(programShareFetchAsync, programShare)

    if (programShareFetch.data.StatusCode === '0000') {
      yield put(programShareFetchSuccess(programShareFetch.data.ResultValues))
    } else {
      yield put(programShareFetchFail(programShareFetch.data.Message))
    }
  } catch (error) {
    yield put(programShareFetchFail(error))
  }
}

const clickProgramShareFetchAsync = async (req) =>
  await API.post('/program/clickshare', req,
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* clickProgramShareFetch({ payload }) {
  const { programShare } = payload
  try {
    const clickProgramShareFetch = yield call(clickProgramShareFetchAsync, programShare)

    if (clickProgramShareFetch.data.StatusCode === '0000') {
      yield put(clickProgramShareFetchSuccess(clickProgramShareFetch.data.ResultValues))
    } else {
      yield put(clickProgramShareFetchFail(clickProgramShareFetch.data.Message))
    }
  } catch (error) {
    yield put(clickProgramShareFetchFail(error))
  }
}

export function* watchProgramFetch() {
  yield takeEvery(BANNER_FETCH, bannerFetch)
  yield takeEvery(BANNER_DETAIL_FETCH, bannerDetailFetch)
  yield takeEvery(CATEGORY_FETCH, categoryFetch)
  yield takeEvery(PROGRAM_DETAIL_FETCH, programDetailFetch)
  yield takeEvery(FAVORITE_SEND_FETCH, favoriteSendFetch)
  yield takeEvery(SEARCH_FETCH, searchFetch)
  yield takeEvery(ALL_PROGRAM_FETCH, allProgramFetch)
  yield takeEvery(PROGRAM_PLAY_FETCH, programPlayFetch)
  yield takeEvery(LIVE_FETCH, liveListFetch)
  yield takeEvery(CURRENT_PLAY_FETCH, currentPlayFetch)
  yield takeEvery(PROGRAM_DETAIL_PREVIEW_FETCH, programDetailPreviewFetch)
  yield takeEvery(SHARE_FETCH, programShareFetch)
  yield takeEvery(CLICK_SHARE_FETCH, clickProgramShareFetch)




}

export default function* rootSaga() {
  yield all([
    fork(watchProgramFetch),
  ]);
}
